import React from "react";
//#region types
import { EditableFormInnerProps, GenericFormField, GenericFormSection } from "models/propTypes/genericFormProps";
import { FormEnums } from "models/enums";
//#endregion
//#region components
import useCheckVisibility from "./hooks/useCheckVisibility";
import useGetHasValueCountWithContext from "./hooks/useGetHasValueCountWithContext";
import RemovableFormFieldWrapper from "./removableFormFieldWrapper";
import { Grid } from "@mui/material";
//#endregion

function ReadOnlyRemovableFormInnerFields<T extends Record<string, any>>(props: EditableFormInnerProps<T>) {
  const { getFieldHidden } = useCheckVisibility<T>();
  const { getHasValueCount } = useGetHasValueCountWithContext<T>();

  const fields = props.fields as Record<keyof T, GenericFormField<T>>;

  return (
    <>
      {Array.isArray(fields)
        ? (fields as GenericFormSection<T>[]).map((section, index) => (
            <ReadOnlyRemovableFormInnerFields<T> key={index} {...props} fields={section.innerFields ?? []} />
          ))
        : Object.entries(fields).map(([key, field], index) => {
            return !getFieldHidden(field.hidden) && !field.hideInReadOnlyRemovableView &&
              (getHasValueCount(field, key) || field.showNotSelectedTextWhenReadOnly) ? (
              field.type === FormEnums.FormFieldType.HORIONTALFIELDGROUP ? (
                <ReadOnlyRemovableFormInnerFields<T> key={index} {...props} fields={field.innerFields ?? []} />
              ) : (
                <Grid item key={`formField-${index}`}>
                  {<RemovableFormFieldWrapper<T> {...props} field={field} name={key} />}
                </Grid>
              )
            ) : (
              <React.Fragment key={`formField-${index}`}></React.Fragment>
            );
          })}
    </>
  );
}

export default ReadOnlyRemovableFormInnerFields;
